(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coupon-list"] && !Shopify.designMode) return;
  try {
    
  // ---- コピー ボタン ----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.coupon-ticket__copy-btn');
    if (!btn) return;
    var targetId = btn.getAttribute('data-copy-target');
    var codeEl = document.getElementById(targetId);
    if (!codeEl) return;
    var text = codeEl.textContent.trim();
    navigator.clipboard.writeText(text).then(function () {
      var original = btn.textContent;
      btn.textContent = 'コピーしました';
      setTimeout(function () {
        btn.textContent = original;
      }, 1500);
    });
  });

  // ---- 確認モーダルの開閉 ----
  var modalOverlay = document.getElementById('coupon-modal');
  var modalText = document.getElementById('coupon-modal-text');
  var pendingAction = null; // { type, tag, code, ticketEl }

  var MODAL_TEXT_STORE =
    '店舗でクーポンを利用しますか？\n※利用するを選択すると、そこから10分間のみ有効となりますのでご注意ください';
  var MODAL_TEXT_ONLINE =
    'オンラインストアでクーポンを利用しますか？\n※利用するを選択すると、クーポンコードが表示されますので、コピーしてチェックアウト画面でご入力ください。ご利用後、こちらの画面から削除されます。';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-open-modal]');
    if (!btn) return;

    var type = btn.getAttribute('data-open-modal');
    var tag = btn.getAttribute('data-coupon-tag');
    var code = btn.getAttribute('data-coupon-code') || null;
    var ticketEl = btn.closest('.coupon-ticket');

    pendingAction = { type: type, tag: tag, code: code, ticketEl: ticketEl };
    modalText.textContent = type === 'store' ? MODAL_TEXT_STORE : MODAL_TEXT_ONLINE;
    modalOverlay.hidden = false;
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-modal-cancel]') || e.target === modalOverlay) {
      modalOverlay.hidden = true;
      pendingAction = null;
    }
  });

  // ---- 確認モーダルの「利用する」 ----
  var COUPON_USE_ENDPOINT = 'https://tol-coupon.h-kiuchi-cf0.workers.dev/';

  // 開発用テストモード: URLに ?coupon_test=1 を付けるとAPI呼び出しをスキップして
  // 見た目・挙動だけ確認できる（バックエンド未実装のうちの動作確認用）
  var isTestMode = new URLSearchParams(window.location.search).get('coupon_test') === '1';

  document.addEventListener('click', function (e) {
    var confirmBtn = e.target.closest('[data-modal-confirm]');
    if (!confirmBtn || !pendingAction) return;

    var action = pendingAction;

    // ---- オンライン利用の場合 ----
    // タグの付与/削除は注文作成時のShopify Flow側で行うため、
    // ここではWorkerを呼ばずその場でコードを表示するだけでよい。
    if (action.type === 'online') {
      revealTicket(action);
      modalOverlay.hidden = true;
      pendingAction = null;
      return;
    }

    // ---- 店舗利用の場合 ----
    // 「_使用済」タグの付与をWorker経由で行い、以後10分間だけバーコードを表示する。
    var wrap = document.querySelector('.coupon-list-wrap');
    var customerId = wrap ? wrap.getAttribute('data-customer-id') : null;

    confirmBtn.disabled = true;

    var request = isTestMode
      ? Promise.resolve({ ok: true })
      : fetch(COUPON_USE_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            customer_id: customerId,
            coupon_tag: action.tag,
            usage_type: action.type
          })
        });

    request
      .then(function (res) {
        if (!res.ok) throw new Error('use request failed');
        revealTicket(action);
        modalOverlay.hidden = true;
        pendingAction = null;
      })
      .catch(function () {
        alert(
          '処理に失敗しました。時間をおいて再度お試しください。\n' +
            '（バックエンド未実装の間は失敗するのが正常です。見た目だけ確認したい場合はURLの末尾に ?coupon_test=1 を付けてください）'
        );
      })
      .finally(function () {
        confirmBtn.disabled = false;
      });
  });

  function revealTicket(action) {
    if (!action.ticketEl) return;
    var idleEl = action.ticketEl.querySelector('.coupon-ticket__idle');
    var revealedEl = action.ticketEl.querySelector('.coupon-ticket__revealed');
    if (idleEl) idleEl.hidden = true;
    if (revealedEl) revealedEl.hidden = false;

    if (action.type === 'store') {
      var storageKey = 'coupon_used_at_' + action.tag;
      localStorage.setItem(storageKey, String(Date.now()));
      startCountdown(action.ticketEl, Date.now());
    }
  }

  // ---- 店舗チケットのカウントダウン（10分、ローカル保存で再読み込みにも対応） ----
  var REVEAL_WINDOW_MS = 10 * 60 * 1000;

  function startCountdown(ticketEl, usedAtMs) {
    var countdownEl = ticketEl.querySelector('[data-countdown]');
    if (!countdownEl) return;

    var timer = setInterval(function () {
      var remaining = REVEAL_WINDOW_MS - (Date.now() - usedAtMs);
      if (remaining <= 0) {
        clearInterval(timer);
        countdownEl.textContent = 'まもなく表示が終了します';
        return;
      }
      var m = Math.floor(remaining / 60000);
      var s = Math.floor((remaining % 60000) / 1000);
      countdownEl.textContent = '残り ' + m + '分' + (s < 10 ? '0' : '') + s + '秒';
    }, 1000);
  }

  // ページ読み込み時、既に「使用済」状態の店舗チケットがあれば
  // localStorageのusedAtから残り時間を復元する
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.coupon-ticket--store').forEach(function (ticketEl) {
      var revealedEl = ticketEl.querySelector('.coupon-ticket__revealed');
      if (!revealedEl || revealedEl.hidden) return;

      var tag = ticketEl.getAttribute('data-coupon-tag');
      var stored = localStorage.getItem('coupon_used_at_' + tag);
      if (stored) {
        startCountdown(ticketEl, parseInt(stored, 10));
      }
      // storedが無い場合（別端末等）はカウントダウンせず、
      // 「まもなく表示が終了します」の静的表示のままにする
    });
  });

  // ---- バーコードのフルスクリーン表示（タップで拡大） ----
  var fullscreenEl = document.getElementById('coupon-fullscreen');
  var fullscreenImg = document.getElementById('coupon-fullscreen-image');

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.coupon-ticket__barcode img');
    if (!trigger) return;

    fullscreenImg.src = trigger.src;
    fullscreenEl.hidden = false;
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-fullscreen-close]')) {
      fullscreenEl.hidden = true;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
